import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Button from 'brandComponents/Button';
import {useBasket} from 'brandHooks';

import {ICouponCta} from './ICouponCta';
import messages from './messages';

import styles from './CouponCta.module.scss';

const CouponCta = ({label, couponCode}: ICouponCta) => {
	const [message, setMessage] = useState('');
	const [isError, setIsError] = useState(false);
	const basket = useBasket();
	const intl = useIntl();

	const handleCouponApply = async () => {
		try {
			await basket.applyPromoCode(couponCode);
			setMessage(intl.formatMessage(messages.successMessage));
		} catch (e) {
			const isAlreadyApplied = !!basket.couponItems?.find((item) => item.code === couponCode);
			setMessage(intl.formatMessage(messages[isAlreadyApplied ? 'alreadyApplied' : 'errorMessage']));
			setIsError(true);
		}
	};

	return (
		<div className={styles['coupon-cta']}>
			<Button
				variant="primary"
				classNames={styles['coupon-cta__button']}
				onClick={handleCouponApply}
			>
				{label}
			</Button>
			<div className={cn(styles['coupon-cta__message'], {
				[styles['coupon-cta__message--error']]: isError,
			})}>
				{message}
			</div>
		</div>
	);
};

export default CouponCta;
